<app-pias-layout>
    <div pias-layout-content>
        <div class="blog-wrapper">
            <div id="events-training-container" class="container-fluid">
                <div id="events-training-carousel-container">

                    <div class="carousel">
    <span class="nav prev" (click)="move(-1)">‹</span>

    <div class="cards">
        <div *ngFor="let card of upcomingeventcards; let i = index" class="card" [ngClass]="getPosition(i)"
            (click)="goTo(card.sectionId, i)">
            <img src="{{ card.image }}" alt="{{ card.title }}" class="card-img">
        </div>
    </div>

    <span class="nav next" (click)="move(1)">›</span>

    <div class="counter">{{ current + 1 | number:'2.0' }} / {{ total | number:'2.0' }}</div>

    <div class="dots">
        <div *ngFor="let card of upcomingeventcards; let i = index" class="dot" [class.active]="i === current"
            (click)="goTo(i)"></div>
    </div>
</div>
                </div>
                <div id="events-training-header" class="d-flex justify-content-between">
                    <h5 class="page-header">Events & Training</h5>
                </div>
                <div id="upcoming-events-training-container" class="container-fluid">
                    <mat-accordion>
                        <mat-expansion-panel id="upcoming-events-training-container-exapansion-panel" [expanded]="true">
                            <mat-expansion-panel-header>
                                <mat-panel-title id="upcoming-events-training-container-exapansion-header">
                                    <h5 class="page-header">Upcoming Events & Training</h5>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <!-- <mat-divider class="pias-divider"></mat-divider> -->
                            <div class="info-wrapper" *ngFor="let card of upcomingeventcards; let i = index">

                                <section class="info-card" id="{{card.sectionId}}">

                                    <div class="section-header">
                                        <h2>{{card.title}}</h2>
                                        <div class="line"></div>
                                    </div>

                                    <div class="info-content">
                                        <!-- (click)="toggleCard(i)" -->
                                        <div class="image-area">
                                            <img src="{{card.image}}">
                                        </div>

                                    </div>

                                </section>
                                <!-- *ngIf="activeIndex === i" -->
                                <div *ngIf="card.content.length > 0">
                                    <div class="card shadow-sm border-0 rounded-3 mb-3">
                                        <div class="card-body p-4 border-start border-4 border-primary">
                                            <ul class="content-list">
                                                <li *ngFor="let topic of card.content">{{ topic }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <br>
                <div id="past-events-training-container" class="container-fluid">
                    <mat-accordion>
                        <mat-expansion-panel id="past-events-training-container-exapansion-panel" [expanded]="false">
                            <mat-expansion-panel-header>
                                <mat-panel-title id="past-events-training-container-exapansion-header">
                                    <h5 class="page-header">Past Events & Training</h5>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <!-- <mat-divider class="pias-divider"></mat-divider> -->
                            <div class="info-wrapper" *ngFor="let card of pasteventcards; let i = index">

                                <section class="info-card" id="{{card.sectionId}}">

                                    <div class="section-header">
                                        <h2>{{card.title}}</h2>
                                        <div class="line"></div>
                                    </div>

                                    <div class="info-content">

                                        <div class="image-area">
                                            <img src="{{card.image}}">
                                        </div>

                                    </div>

                                </section>

                            </div>

                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <br>
            </div>
        </div>
    </div>
</app-pias-layout>